import { apiBlob, apiRequest } from '@/lib/apiClient';
import type { GuiaDto, MonthSummary, OcrResult, SaveGuiaRequest } from '@/types';

export const listGuias = (mes: string) =>
  apiRequest<GuiaDto[]>(`/api/guias?month=${encodeURIComponent(mes)}`);

export const getSummary = (mes: string) =>
  apiRequest<MonthSummary>(`/api/guias/summary?month=${encodeURIComponent(mes)}`);

export const checkGuiaNumero = (numero: string, excludeId?: string) =>
  apiRequest<{ exists: boolean; existing: GuiaDto | null }>(
    `/api/guias/check?numero=${encodeURIComponent(numero)}${excludeId ? `&excludeId=${excludeId}` : ''}`,
  );

export const createGuia = (body: SaveGuiaRequest) =>
  apiRequest<GuiaDto>('/api/guias', { method: 'POST', body });

export const updateGuia = (id: string, body: SaveGuiaRequest) =>
  apiRequest<GuiaDto>(`/api/guias/${id}`, { method: 'PUT', body });

export const deleteGuia = (id: string) =>
  apiRequest<void>(`/api/guias/${id}`, { method: 'DELETE' });

export const clearDemo = () =>
  apiRequest<{ removed: number }>('/api/guias/demo', { method: 'DELETE' });

export const ocrGuia = (file: File) => {
  const form = new FormData();
  form.append('file', file);
  return apiRequest<OcrResult>('/api/guias/ocr', { method: 'POST', form });
};

export const exportCsv = (mes: string) =>
  apiBlob(`/api/guias/export?month=${encodeURIComponent(mes)}`);

export const exportAnnual = (ano: number) => apiBlob(`/api/guias/export-annual?year=${ano}`);
